import './brandTable.scss'
export const highlightMatch = (text?: string, query?: string) => {
  if (!text) return null
  if (!query) return text

  const parts = text.split(new RegExp(`(${query})`, 'gi'))

  return parts.map((part, i) =>
    part.toLowerCase() === query.toLowerCase() ? (
      <mark key={i} className="highlighted-text subtitle-s">
        {part}
      </mark>
    ) : (
      part
    ),
  )
}
